var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDonorregisterOpen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 279.03 210.19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #a6a6a6;\n      }\n\n      .cls-3 {\n        fill: #cadce6;\n      }\n\n      .cls-4 {\n        fill: #ebebeb;\n      }\n\n      .cls-5 {\n        isolation: isolate;\n        opacity: .1;\n      }\n\n      .cls-6 {\n        fill: #3c474c;\n      }\n\n      .cls-7 {\n        fill: #263238;\n      }\n\n      .cls-8 {\n        fill: #bd4f5c;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m28.98,53.78h-2.43v8.6h2.43c1.99-.01,3.3-1.31,3.3-4.28s-1.3-4.33-3.3-4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m274.5,91.87V24.24H4.53v51.28h10.56v5.48H4.53v10.87h269.97Zm-161.42-4h-12.98v-5.49h12.98v5.49Zm28.26-21.44v-16.69h13.55v4.26h-8.09v2.29h6.76v3.6h-6.76v2.29h8.09v4.25h-13.55Zm6.1-19.88v-5.49h12.98v5.49h-12.98Zm41.29,36.79v-5.49h12.98v5.49h-12.98Zm-7.24-6.93v-5.49h12.98v5.49h-12.98Zm69.75,6.93h-12.98v-5.49h12.98v5.49Zm23.26-36.78h-6.49v-5.49h6.49v5.49Zm-13.9-12.42h12.98v5.49h-12.98v-5.49Zm-9.41,15.61c3.79,0,6.09,2.44,6.09,5.84,0,2.31-1,4.16-2.76,5.15l3.42,5.7h-5.72l-2.74-4.9h-2.41v4.9h-5.46v-16.69h9.58Zm-27.14,0h13.55v4.26h-8.09v2.29h6.76v3.6h-6.76v2.29h8.09v4.25h-13.55v-16.69Zm-17.6,0h14.23v4.26h-4.39v12.43h-5.45v-12.43h-4.4v-4.26Zm-10.22-.33c3.72,0,6.28,1.54,7.1,3.85.2.54.31,1.11.3,1.73h-5.34c0-.33-.08-.64-.25-.88-.33-.61-1.12-.96-2.2-.96-1.3,0-2.16.38-2.16,1.12.01,1,2.61,1.54,4.93,2.19,3.13.89,5.19,2.19,5.21,4.83.02,3.28-2.59,5.48-7.74,5.48-4.03,0-6.72-1.67-7.65-4.1-.26-.57-.39-1.19-.39-1.81h5.48c0,.29.06.57.21.82.33.64,1.2,1.08,2.44,1.08s2.13-.49,2.13-1.26c0-1.18-2.51-1.55-4.67-2.15-2.92-.79-5.26-2.28-5.26-4.67,0-3.36,2.96-5.27,7.84-5.27Zm-11.81.33v16.69h-5.46v-16.69h5.46Zm-9.57,5.86h-5.6c-.31-1.23-1.41-1.92-2.74-1.92-1.94,0-3.18,1.39-3.18,4.4s1.24,4.39,3.18,4.39c1.53,0,2.66-.94,2.97-2.6h-3.55v-3.19h9.08v9.75h-3.81l-.2-2.35c-.87,1.74-2.43,2.68-5.27,2.68-4.47,0-7.84-2.84-7.84-8.68s3.37-8.68,8.63-8.68c4.47,0,7.72,2.05,8.34,6.2Zm-20.18-21.47h12.98v5.49h-12.98v-5.49Zm-14.48,0h12.98v5.49h-12.98v-5.49Zm-8.72,15.61c3.79,0,6.09,2.44,6.09,5.84,0,2.31-1,4.16-2.76,5.15l3.42,5.7h-5.72l-2.74-4.9h-2.41v4.9h-5.46v-16.69h9.58Zm-29.03,0h9.58c3.79,0,6.09,2.44,6.09,5.84,0,2.31-1,4.16-2.76,5.15l3.42,5.7h-5.72l-2.74-4.9h-2.41v4.9h-5.46v-16.69Zm-39.05-15.61h12.98v5.49h-12.98v-5.49Zm-40.64,53.73h-12.98v-5.49h12.98v5.49Zm6.24-21.44h-7.89v-16.69h7.89c5.26,0,8.75,2.86,8.75,8.37s-3.49,8.32-8.75,8.32Zm20.5.33c-5.24,0-8.62-2.84-8.62-8.68s3.37-8.68,8.62-8.68,8.64,2.84,8.64,8.68-3.39,8.68-8.64,8.68Zm28.6-.33h-5.73l-5.24-8.33v8.33h-5.46v-16.69h5.75l5.24,8.33v-8.33h5.45v16.69Zm12.18-17.02c5.26,0,8.64,2.84,8.64,8.68s-3.38,8.68-8.64,8.68-8.62-2.84-8.62-8.68,3.37-8.68,8.62-8.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m251.83,55.69c0-1.29-.69-1.92-1.86-1.92h-2.91v3.84h2.91c1.17,0,1.86-.63,1.86-1.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m132.11,55.69c0-1.29-.69-1.92-1.86-1.92h-2.91v3.84h2.91c1.17,0,1.86-.63,1.86-1.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m49.48,53.69c-1.93,0-3.17,1.35-3.17,4.4s1.24,4.4,3.17,4.4,3.18-1.35,3.18-4.4-1.24-4.4-3.18-4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m112.66,55.69c0-1.29-.69-1.92-1.86-1.92h-2.91v3.84h2.91c1.17,0,1.86-.63,1.86-1.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m90.27,62.48c1.94,0,3.18-1.35,3.18-4.4s-1.24-4.4-3.18-4.4-3.17,1.35-3.17,4.4,1.24,4.4,3.17,4.4Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4.53,
    y: 5.54,
    width: 269.97,
    height: 13.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 174.81,
    y: 209.74,
    width: 99.68,
    height: 0
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4.53,
    y: 209.74,
    width: 99.68,
    height: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "174.81 199.38 174.81 190.69 175 190.51 175 170.97 174.81 171.16 174.81 153.58 175 153.39 175 133.26 174.81 133.26 174.81 204.2 175 204.2 175 199.19 174.81 199.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "15.57 204.2 15.57 133.26 15.56 133.26 15.56 128.03 15.57 128.03 15.57 114.82 15.57 109.59 20.79 109.59 139.65 109.59 139.67 109.59 258.52 109.59 263.75 109.59 263.75 114.82 263.75 128.03 263.75 128.03 263.75 133.26 263.75 133.26 263.75 204.2 274.5 204.2 274.5 97.42 4.53 97.42 4.53 204.2 15.57 204.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "104.21 133.26 20.79 133.26 20.79 133.42 40.95 133.42 58.53 133.42 78.07 133.42 86.75 133.42 104.21 133.42 104.21 136.54 104.21 176.77 104.21 189.98 104.21 198.67 104.21 204.2 104.21 204.2 104.21 133.26"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 147.43,
    y: 41.06,
    width: 12.98,
    height: 5.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 147.43,
    y: 41.06,
    width: 12.98,
    height: 5.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 268,
    y: 41.06,
    width: 6.49,
    height: 5.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 268,
    y: 41.06,
    width: 6.49,
    height: 5.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 154.67,
    y: 34.13,
    width: 12.98,
    height: 5.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 154.67,
    y: 34.13,
    width: 12.98,
    height: 5.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 260.6,
    y: 34.13,
    width: 12.98,
    height: 5.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 260.6,
    y: 34.13,
    width: 12.98,
    height: 5.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 140.19,
    y: 34.13,
    width: 12.98,
    height: 5.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 140.19,
    y: 34.13,
    width: 12.98,
    height: 5.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 188.72,
    y: 77.84,
    width: 12.98,
    height: 5.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 188.72,
    y: 77.84,
    width: 12.98,
    height: 5.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 100.1,
    y: 82.38,
    width: 12.98,
    height: 5.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 100.1,
    y: 82.38,
    width: 12.98,
    height: 5.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 9.77,
    y: 82.38,
    width: 12.98,
    height: 5.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 9.77,
    y: 82.38,
    width: 12.98,
    height: 5.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 4.53,
    y: 75.51,
    width: 10.56,
    height: 5.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 4.53,
    y: 75.51,
    width: 10.56,
    height: 5.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 238.25,
    y: 77.84,
    width: 12.98,
    height: 5.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 238.25,
    y: 77.84,
    width: 12.98,
    height: 5.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 181.48,
    y: 70.92,
    width: 12.98,
    height: 5.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 181.48,
    y: 70.92,
    width: 12.98,
    height: 5.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 63.39,
    y: 34.13,
    width: 12.98,
    height: 5.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 63.39,
    y: 34.13,
    width: 12.98,
    height: 5.49
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "279.02 209.74 174.81 209.74 174.81 209.74 274.5 209.74 279.03 209.74 279.03 204.2 279.02 204.2 279.02 209.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "104.21 209.74 104.21 209.74 0 209.74 0 204.2 0 204.2 0 209.74 4.53 209.74 104.21 209.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "274.5 97.42 279.03 97.42 279.03 91.87 274.5 91.87 4.53 91.87 0 91.87 0 97.42 4.53 97.42 274.5 97.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "274.5 97.42 279.03 97.42 279.03 91.87 274.5 91.87 4.53 91.87 0 91.87 0 97.42 4.53 97.42 274.5 97.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "279.03 24.24 279.03 18.7 274.5 18.7 4.53 18.7 0 18.7 0 24.24 4.53 24.24 274.5 24.24 279.03 24.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "279.03 24.24 279.03 18.7 274.5 18.7 4.53 18.7 0 18.7 0 24.24 4.53 24.24 274.5 24.24 279.03 24.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "279.03 5.54 279.03 0 0 0 0 5.54 4.53 5.54 274.5 5.54 279.03 5.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "279.03 5.54 279.03 0 0 0 0 5.54 4.53 5.54 274.5 5.54 279.03 5.54"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 0,
    y: 204.2,
    width: 4.53,
    height: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "104.21 209.74 104.21 204.2 104.21 204.2 104.21 204.2 98.68 204.2 89.99 204.2 76.79 204.2 36.55 204.2 20.79 204.2 15.57 204.2 15.57 204.2 4.53 204.2 4.53 204.2 0 204.2 0 209.74 104.21 209.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "104.21 209.74 104.21 204.2 104.21 204.2 104.21 204.2 98.68 204.2 89.99 204.2 76.79 204.2 36.55 204.2 20.79 204.2 15.57 204.2 15.57 204.2 4.53 204.2 4.53 204.2 0 204.2 0 209.74 104.21 209.74"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 274.5,
    y: 204.2,
    width: 4.53,
    height: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "263.75 204.2 258.76 204.2 258.52 204.2 258.23 204.2 252.7 204.2 244.02 204.2 230.81 204.2 190.57 204.2 175 204.2 175 204.2 174.81 204.2 174.81 209.74 279.02 209.74 279.02 204.2 274.5 204.2 274.5 204.2 263.75 204.2 263.75 204.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "263.75 204.2 258.76 204.2 258.52 204.2 258.23 204.2 252.7 204.2 244.02 204.2 230.81 204.2 190.57 204.2 175 204.2 175 204.2 174.81 204.2 174.81 209.74 279.02 209.74 279.02 204.2 274.5 204.2 274.5 204.2 263.75 204.2 263.75 204.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "174.81 204.2 174.81 133.26 174.81 128.03 174.77 128.03 166.09 128.03 152.88 128.03 112.64 128.03 104.21 128.03 104.21 133.26 104.21 204.2 104.21 209.74 174.81 209.74 174.81 204.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "174.81 209.74 104.21 209.74 104.21 209.74 104.21 209.74 104.21 210.19 174.81 210.19 174.81 209.74 174.81 209.74 174.81 209.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "20.79 153.58 40.95 133.42 20.79 133.42 20.79 153.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "20.79 190.69 78.07 133.42 58.53 133.42 20.79 171.16 20.79 190.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "104.21 136.54 104.21 133.42 86.75 133.42 20.79 199.38 20.79 204.2 36.55 204.2 104.21 136.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "104.21 189.98 104.21 176.77 76.79 204.2 89.99 204.2 104.21 189.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "98.68 204.2 104.21 204.2 104.21 204.2 104.21 198.67 98.68 204.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "20.79 199.38 20.79 190.69 20.79 171.16 20.79 153.58 20.79 133.42 20.79 133.26 15.57 133.26 15.57 204.2 15.57 204.2 20.79 204.2 20.79 199.38"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 15.57,
    y: 114.82,
    width: 5.23,
    height: 13.21
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "104.21 133.26 104.21 128.03 92.06 128.03 83.38 128.03 63.85 128.03 46.27 128.03 20.79 128.03 20.79 128.03 15.57 128.03 15.56 128.03 15.56 133.26 15.57 133.26 20.79 133.26 104.21 133.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "59.48 114.82 77.06 114.82 96.59 114.82 105.28 114.82 125.85 114.82 139.65 114.82 139.65 109.59 20.79 109.59 15.57 109.59 15.57 114.82 20.79 114.82 59.48 114.82"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 258.52,
    y: 114.82,
    width: 5.23,
    height: 13.21
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "258.76 133.26 258.76 204.2 263.75 204.2 263.75 204.2 263.75 133.26 258.76 133.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "258.52 128.03 258.23 128.03 246.19 128.03 237.5 128.03 217.97 128.03 200.39 128.03 174.81 128.03 174.81 133.26 175 133.26 175 133.26 258.76 133.26 258.76 133.26 263.75 133.26 263.75 133.26 263.75 128.03 263.75 128.03 258.52 128.03 258.52 128.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "139.67 114.82 166.09 114.82 179.3 114.82 187.98 114.82 213.6 114.82 231.18 114.82 250.72 114.82 258.23 114.82 258.52 114.82 263.75 114.82 263.75 109.59 258.52 109.59 139.67 109.59 139.65 109.59 139.65 114.82 139.67 114.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "20.79 171.16 58.53 133.42 40.95 133.42 20.79 153.58 20.79 171.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "20.79 190.69 20.79 199.38 86.75 133.42 78.07 133.42 20.79 190.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "104.21 198.67 104.21 189.98 89.99 204.2 98.68 204.2 104.21 198.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "104.21 176.77 104.21 136.54 36.55 204.2 76.79 204.2 104.21 176.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "258.76 133.26 258.76 133.26 175 133.26 175 133.26 175 153.39 194.98 133.42 212.56 133.42 175 170.97 175 190.51 232.09 133.42 240.77 133.42 175 199.19 175 204.2 175 204.2 190.57 204.2 258.23 136.54 258.23 176.77 230.81 204.2 244.02 204.2 258.23 189.98 258.23 198.67 252.7 204.2 258.23 204.2 258.52 204.2 258.76 204.2 258.76 133.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "96.59 114.82 77.06 114.82 63.85 128.03 83.38 128.03 96.59 114.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "59.48 114.82 20.79 114.82 20.79 128.03 20.79 128.03 46.27 128.03 59.48 114.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "125.85 114.82 105.28 114.82 92.06 128.03 104.21 128.03 112.64 128.03 125.85 114.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "258.23 115.98 246.19 128.03 258.23 128.03 258.52 128.03 258.52 128.03 258.52 114.82 258.23 114.82 258.23 115.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "179.3 114.82 166.09 114.82 152.88 128.03 166.09 128.03 179.3 114.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "217.97 128.03 237.5 128.03 250.72 114.82 231.18 114.82 217.97 128.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "200.39 128.03 213.6 114.82 187.98 114.82 174.77 128.03 174.81 128.03 200.39 128.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "174.81 171.16 175 170.97 212.56 133.42 194.98 133.42 175 153.39 174.81 153.58 174.81 171.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "174.81 199.38 175 199.19 240.77 133.42 232.09 133.42 175 190.51 174.81 190.69 174.81 199.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "258.23 198.67 258.23 189.98 244.02 204.2 252.7 204.2 258.23 198.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "258.23 176.77 258.23 136.54 190.57 204.2 230.81 204.2 258.23 176.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "77.06 114.82 59.48 114.82 46.27 128.03 63.85 128.03 77.06 114.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "105.28 114.82 96.59 114.82 83.38 128.03 92.06 128.03 105.28 114.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "187.98 114.82 179.3 114.82 166.09 128.03 174.77 128.03 187.98 114.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "166.09 114.82 139.67 114.82 139.65 114.82 125.85 114.82 112.64 128.03 152.88 128.03 166.09 114.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "200.39 128.03 217.97 128.03 231.18 114.82 213.6 114.82 200.39 128.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "237.5 128.03 246.19 128.03 258.23 115.98 258.23 114.82 250.72 114.82 237.5 128.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m28.98,49.74h-7.89v16.69h7.89c5.26,0,8.75-2.81,8.75-8.32s-3.49-8.37-8.75-8.37Zm0,12.65h-2.43v-8.6h2.43c2,0,3.3,1.36,3.3,4.33s-1.31,4.27-3.3,4.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m49.48,49.41c-5.24,0-8.62,2.84-8.62,8.68s3.37,8.68,8.62,8.68,8.64-2.84,8.64-8.68-3.39-8.68-8.64-8.68Zm0,13.08c-1.93,0-3.17-1.35-3.17-4.4s1.24-4.4,3.17-4.4,3.18,1.35,3.18,4.4-1.24,4.4-3.18,4.4Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "72.64 58.07 67.4 49.74 61.65 49.74 61.65 66.43 67.11 66.43 67.11 58.1 72.35 66.43 78.09 66.43 78.09 49.74 72.64 49.74 72.64 58.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m90.27,66.76c5.26,0,8.64-2.84,8.64-8.68s-3.38-8.68-8.64-8.68-8.62,2.84-8.62,8.68,3.37,8.68,8.62,8.68Zm0-13.08c1.94,0,3.18,1.35,3.18,4.4s-1.24,4.4-3.18,4.4-3.17-1.35-3.17-4.4,1.24-4.4,3.17-4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m107.9,66.43v-4.9h2.41l2.74,4.9h5.72l-3.42-5.7c1.76-.99,2.76-2.84,2.76-5.15,0-3.4-2.3-5.84-6.09-5.84h-9.58v16.69h5.46Zm0-12.66h2.91c1.17,0,1.86.63,1.86,1.92s-.69,1.92-1.86,1.92h-2.91v-3.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m121.89,66.43h5.46v-4.9h2.41l2.74,4.9h5.72l-3.42-5.7c1.76-.99,2.76-2.84,2.76-5.15,0-3.4-2.3-5.84-6.09-5.84h-9.58v16.69Zm5.46-12.66h2.91c1.17,0,1.86.63,1.86,1.92s-.69,1.92-1.86,1.92h-2.91v-3.84Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "154.89 62.17 146.79 62.17 146.79 59.88 153.55 59.88 153.55 56.28 146.79 56.28 146.79 54 154.89 54 154.89 49.74 141.34 49.74 141.34 66.43 154.89 66.43 154.89 62.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m157.88,58.08c0,5.84,3.37,8.68,7.84,8.68,2.84,0,4.4-.94,5.27-2.68l.2,2.35h3.81v-9.75h-9.08v3.19h3.55c-.31,1.66-1.44,2.6-2.97,2.6-1.94,0-3.18-1.38-3.18-4.39s1.24-4.4,3.18-4.4c1.34,0,2.43.69,2.74,1.92h5.6c-.62-4.15-3.87-6.2-8.34-6.2-5.26,0-8.63,2.94-8.63,8.68Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 178.96,
    y: 49.74,
    width: 5.46,
    height: 16.69
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m193.64,59.35c2.16.6,4.67.97,4.67,2.15,0,.77-.86,1.26-2.13,1.26s-2.11-.44-2.44-1.08c-.16-.25-.21-.54-.21-.82h-5.48c0,.62.13,1.24.39,1.81.93,2.43,3.62,4.1,7.65,4.1,5.15,0,7.76-2.21,7.74-5.48-.02-2.63-2.07-3.93-5.21-4.83-2.32-.66-4.92-1.19-4.93-2.19,0-.74.86-1.12,2.16-1.12,1.08,0,1.87.36,2.2.96.17.24.25.55.25.88h5.34c.01-.62-.1-1.19-.3-1.73-.82-2.31-3.38-3.85-7.1-3.85-4.89,0-7.84,1.91-7.84,5.27,0,2.4,2.34,3.89,5.26,4.67Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "210.85 66.43 216.29 66.43 216.29 54 220.68 54 220.68 49.74 206.45 49.74 206.45 54 210.85 54 210.85 66.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "237.6 66.43 237.6 62.17 229.51 62.17 229.51 59.88 236.27 59.88 236.27 56.28 229.51 56.28 229.51 54 237.6 54 237.6 49.74 224.05 49.74 224.05 66.43 237.6 66.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m241.6,66.43h5.46v-4.9h2.41l2.74,4.9h5.72l-3.42-5.7c1.76-.99,2.76-2.84,2.76-5.15,0-3.4-2.3-5.84-6.09-5.84h-9.58v16.69Zm5.46-12.66h2.91c1.17,0,1.86.63,1.86,1.92s-.69,1.92-1.86,1.92h-2.91v-3.84Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m104.21,127.65v82.16h35.14v-82.16h-35.14Zm29.92,10.22v50.53h-24.69v-55.4h24.69v4.87Zm3.27,41.65h-1.7v-9.24h1.7v9.24Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "124.82 133 109.44 148.38 109.44 150.86 127.29 133 124.82 133"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "119.73 172.93 134.13 158.52 134.13 155.85 117.08 172.93 119.73 172.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "109.44 133 109.44 143.54 119.98 133 109.44 133"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "134.13 172.93 134.13 170.2 131.41 172.93 134.13 172.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "109.44 172.93 114.61 172.93 134.13 153.38 134.13 137.87 109.44 162.56 109.44 172.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "115.97 188.4 134.13 188.4 134.13 176.86 127.49 176.86 115.97 188.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "109.44 176.86 109.44 178.11 110.68 176.86 109.44 176.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "113.16 176.86 109.44 180.58 109.44 183.24 115.81 176.86 113.16 176.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "109.44 150.86 109.44 162.56 134.13 137.87 134.13 133 127.29 133 109.44 150.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "131.41 172.93 134.13 170.2 134.13 158.52 119.73 172.93 131.41 172.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "115.81 176.86 109.44 183.24 109.44 188.4 115.97 188.4 127.49 176.86 115.81 176.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "110.68 176.86 109.44 178.11 109.44 180.58 113.16 176.86 110.68 176.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "117.08 172.93 134.13 155.85 134.13 153.38 114.61 172.93 117.08 172.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "119.98 133 109.44 143.54 109.44 148.38 124.82 133 119.98 133"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 135.7,
    y: 170.28,
    width: 1.7,
    height: 9.24
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "119.73 172.93 117.08 172.93 114.61 172.93 109.44 172.93 109.44 176.86 110.68 176.86 113.16 176.86 115.81 176.86 127.49 176.86 134.13 176.86 134.13 172.93 131.41 172.93 119.73 172.93"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m139.65,127.65v82.16h35.14v-82.16h-35.14Zm3.66,51.87h-1.7v-9.24h1.7v9.24Zm26.26-41.65v50.53h-24.69v-55.4h24.69v4.87Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "151.41 188.4 169.56 188.4 169.56 176.86 162.92 176.86 151.41 188.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "160.25 133 144.87 148.38 144.87 150.86 162.73 133 160.25 133"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "155.17 172.93 169.56 158.52 169.56 155.85 152.51 172.93 155.17 172.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "144.87 133 144.87 143.54 155.41 133 144.87 133"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "144.87 172.93 150.04 172.93 169.56 153.38 169.56 137.87 144.87 162.56 144.87 172.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "148.59 176.86 144.87 180.58 144.87 183.24 151.24 176.86 148.59 176.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "144.87 176.86 144.87 178.11 146.11 176.86 144.87 176.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "169.56 172.93 169.56 170.2 166.84 172.93 169.56 172.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "144.87 150.86 144.87 162.56 169.56 137.87 169.56 133 162.73 133 144.87 150.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "151.24 176.86 144.87 183.24 144.87 188.4 151.41 188.4 162.92 176.86 151.24 176.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "166.84 172.93 169.56 170.2 169.56 158.52 155.17 172.93 166.84 172.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "146.11 176.86 144.87 178.11 144.87 180.58 148.59 176.86 146.11 176.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "152.51 172.93 169.56 155.85 169.56 153.38 150.04 172.93 152.51 172.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "155.41 133 144.87 143.54 144.87 148.38 160.25 133 155.41 133"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 141.6,
    y: 170.28,
    width: 1.7,
    height: 9.24
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "155.17 172.93 152.51 172.93 150.04 172.93 144.87 172.93 144.87 176.86 146.11 176.86 148.59 176.86 151.24 176.86 162.92 176.86 169.56 176.86 169.56 172.93 166.84 172.93 155.17 172.93"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDonorregisterOpen);
export default __webpack_public_path__ + "static/media/donorregister_open.7071f69b982288664f5b28d8150be753.svg";
export { ForwardRef as ReactComponent };